/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2018-2-1
 *    
 */
// import T from '@idev4/lake';
import leaflet from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './leaflet.css';
import '@/Polyfill';
import Map from '@/Map';
import './dmap-font.css';
//
import {
  wgs84togcj02,
  gcj02towgs84
} from '@/utils/coordtransform';
//
// 注册 leaflet 模块，amd
T.declare && T.declare({
  leaflet
});
// 
var L = T.leaflet = {};
// 
L.Map = Map;
L.map = (node, options) => new Map(node, options);
L.WGS84ToGCJ02 = point => wgs84togcj02(point[0], point[1]);
L.GCJ02ToWGS84 = point => gcj02towgs84(point[0], point[1]);
L.WGS84ToCGCS2000 = point => L.transform("WGS84", "CGCS2000", point);
L.CGCS2000ToWGS84 = point => L.transform("CGCS2000", "WGS84", point)
L.GCG02ToCGCS2000 = point => L.WGS84ToCGCS2000(L.GCJ02ToWGS84(point))
L.CGCS2000ToGCG02 = point => L.WGS84ToGCJ02(L.CGCS2000ToWGS84(point));
L.transform = require('../src/crs/Proj').transform;
//
export default L;



// WEBPACK FOOTER //
// ./entry/leaflet.js